import React, { useState, useCallback, useRef, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useHistory } from 'react-router-dom';
import ComplexArtboard from './ComplexArtboard';
import ComplexArtboardSidebar from './ComplexArtboardSidebar';
import {
  Container, Wrapper, ComplexArtboardWrapper, DocumentContainer,
  ToolbarContainer, PagesWrapper
} from './styles';
import withScrolling from '../../components/ScrollZone';
import ComplexDocumentHistoryProvider from '../../context/complexDocumentContext';
import ComplexArtboardProvider, { useArtboardContext } from '../../context/complexArtboardContext';
import ComplexTextEditingProvider from '../../context/complexTextEditingContext';
import { COMPLEX_DOCUMENT_PAGE_WRAPPER } from '../../utils/complexDocumentConstants';
import BusinessLogicProvider from '../../context/businessLogicContext';
import MenuBar from './MenuBar';
import { CONTEXT_KEYS } from '../../context/complexArtboardContext';
import FontsProvider from '../../context/fontsContext';
import { ModalPopupContainer } from './ComplexPdfInserts/styles';
import { TabMenuItemContainer } from '../SidebarMenu/styles';
import CreateTemplateModal from '../../components/CreateNewTemplate/CreateTemplateModal';
import { useSessionContext } from '../../context/sessionContext';
import SaasSetupLoader from '../LandingPage/SaasSetupLoader';

const ComplexArtboardContainer = ({ TemplateId, pageWrapperRef }) => {

  const history = useHistory();

  const previewSelector = useCallback(store => store[CONTEXT_KEYS.IS_PREVIEW], []);
  const [isPreview] = useArtboardContext(previewSelector);

  const accessibilitySelector = useCallback(store => store[CONTEXT_KEYS.CHECK_ACCESSIBILITY], []);
  const [accessibilityView] = useArtboardContext(accessibilitySelector);

  const isOpenDesignSelector = useCallback(store => store[CONTEXT_KEYS.IS_OPEN_DESIGN], []);
  const [isOpenDesign] = useArtboardContext(isOpenDesignSelector);

  const masterCloneSelector = useCallback(store => store[CONTEXT_KEYS.OPEN_MASTER_CLONE], []);
  const [masterClone] = useArtboardContext(masterCloneSelector);

  const organisationSelector = useCallback(store => store, []);
  const [organisationDetails] = useSessionContext(organisationSelector);

  const [autoCreateTemplate, setAutoCreateTemplate] = useState(false);
  const documentIdRef = useRef(null);

  const handleTemplateCreation = useCallback((documentId) => {
    history.push(`/design/${documentId}`);
  }, []);

  return (
    <div style={{ display: `${(isPreview || accessibilityView) ? 'none' : 'contents'}` }}>
      <ComplexArtboard templateId={TemplateId} visibilityRef={pageWrapperRef} />
    {isOpenDesign && masterClone !== undefined && (
      <>
      {organisationDetails?.accessTokenPayload?.firstLogin && 
        <SaasSetupLoader 
          createDefaultTemplate={() => setAutoCreateTemplate(true)}
          onSuccess={() => handleTemplateCreation(documentIdRef.current)}
          isOpenDesign
        />
      }
      <CreateTemplateModal
        visible={true}
        onSucess={(response) => {
          if(autoCreateTemplate)
            documentIdRef.current = response?.documentId;
          else
            handleTemplateCreation(response?.documentId);
        }}
        selectDesign={false}
        isOpenDesign={true}
        template={masterClone}
        categoryId={masterClone?.categoryId}
        autoCreateTemplate={autoCreateTemplate}
        firstLogin={organisationDetails?.accessTokenPayload?.firstLogin}
      />
      </>)}
    </div>
  );
};

const ComplexDesignMenuBar = () => {
  const customCurrentBlockSelector = useCallback((store) => store[CONTEXT_KEYS.CURRENT_BLOCK], []);
  const [currentEditingBlock] = useArtboardContext(customCurrentBlockSelector);

  const previewEnabledSelector = useCallback((store) => store[CONTEXT_KEYS.PREVIEW_AND_DOWNLOAD], []);
  const [isPreviewEnabled] = useArtboardContext(previewEnabledSelector);

  return (
    !currentEditingBlock && !isPreviewEnabled && <MenuBar />
  );
};

// TODO : Integrate with lock API to acquire lock on template
const ComplexDocumentDesign = ({ customState = {}, masterVariables = undefined, isOpenDesign = false }) => {
  const { documentId , flowId , blockId } = useParams();  
  const TemplateId = documentId || flowId || blockId ;
  const pageWrapperRef = useRef(undefined);  
  
  const ScrollingComponent = useMemo(() => withScrolling(PagesWrapper, pageWrapperRef), []);

  return (
    <Container>
      <Wrapper>
        <DndProvider backend={HTML5Backend} key={1} context={window}>
          <ComplexDocumentHistoryProvider masterVariables={masterVariables} isOpenDesign={isOpenDesign}>
            <ComplexArtboardProvider documentId={TemplateId} customState={customState}>
            <BusinessLogicProvider>
              <FontsProvider isOpen={isOpenDesign}>
                <ComplexTextEditingProvider>
                <ComplexArtboardSidebar />
                <ComplexArtboardWrapper>
                  <div className="moveable-label" />
                  <DocumentContainer>
                    <ToolbarContainer /*id="document-editor-toolbar"*/></ToolbarContainer>
                    <ScrollingComponent id={COMPLEX_DOCUMENT_PAGE_WRAPPER} tabIndex={-1}>
                      <div id="preview-portal" style={{height:'100%', width:'100%'}}></div>
                      <ComplexArtboardContainer TemplateId={TemplateId} pageWrapperRef={pageWrapperRef}/>
                    </ScrollingComponent>
                    <TabMenuItemContainer style={{zIndex: 3001}}>
                      <ModalPopupContainer id="modal-popup-insert-container" />
                    </TabMenuItemContainer>
                    <ComplexDesignMenuBar />
                  </DocumentContainer>
                </ComplexArtboardWrapper>
                </ComplexTextEditingProvider>
              </FontsProvider>  
            </BusinessLogicProvider>
            </ComplexArtboardProvider>
          </ComplexDocumentHistoryProvider>
        </DndProvider>
      </Wrapper>
    </Container>
  );
};

export default ComplexDocumentDesign;
